import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { createUrlObject, getUrlObjectHref, isNullOrWhitespace, pathJoin } from '@asamco/utils';
import { Observable } from 'rxjs';

import { BASE_API_ADDRESS_PROVIDER, IBaseApiAddressProvider } from './base-api-address-provider';

/**
 * Interceptor that will add the base url
 */
@Injectable({
	providedIn: 'root',
	deps: [BASE_API_ADDRESS_PROVIDER],
})
export class ApiUrlInterceptorService implements HttpInterceptor {
	constructor(@Inject(BASE_API_ADDRESS_PROVIDER) private baseApiAddressProvider: IBaseApiAddressProvider) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Don't update the url if it starts with http(s)
		if (!/^https?:\/\//.test(request.url)) {
			const baseUrl = this.baseApiAddressProvider.getBaseUrl(request);

			if (!isNullOrWhitespace(baseUrl)) {
				const newUrl = this.buildUrl(baseUrl, request.url);

				request = request.clone({
					url: newUrl,
				});
			}
		}

		return next.handle(request);
	}

	private buildUrl(baseUrl: string, path: string) {
		let newUrl;
		// All paths starting with a '/' wants to start from the real root, without /api suffix
		if (path.startsWith('/')) {
			const rootAddress = createUrlObject(baseUrl).origin;
			newUrl = createUrlObject(pathJoin([rootAddress, path]));
		} else {
			// Other paths, should be appended
			newUrl = createUrlObject(pathJoin([baseUrl, path]));
		}

		return getUrlObjectHref(newUrl);
	}
}
